import React from 'react';
import MoodMessenger from './MoodMessenger';
import LoveReasonGenerator from './LoveReasonGenerator';
import SpotifyPlayer from './SpotifyPlayer';
import CountdownTimer from './CountdownTimer';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>For Toto 💖</h1>

      <div className="section">
        <CountdownTimer />
      </div>

      <div className="section">
        <MoodMessenger />
      </div>

      <div className="section">
        <LoveReasonGenerator />
      </div>

      <div className="section">
        <SpotifyPlayer />
      </div>
      
    </div>
  );
}

export default App;
